import { Controller } from "@hotwired/stimulus"

// Accordion for the people index: a row header toggles its preview panel,
// and opening one row closes any other so the list stays scannable.
export default class extends Controller {
  static targets = [ "row" ]

  toggle(event) {
    if (event.target.closest("a, button, form, input")) return
    event.preventDefault()

    const row = event.currentTarget.closest("[data-people-rows-target='row']")
    const wasOpen = !this.#panel(row).classList.contains("hidden")

    this.rowTargets.forEach((other) => this.#close(other))
    if (!wasOpen) this.#open(row)
  }

  #open(row) {
    this.#panel(row).classList.remove("hidden")
    this.#header(row).setAttribute("aria-expanded", "true")
    this.#header(row).classList.add("bg-foot")
    this.#chevron(row).classList.add("rotate-180", "text-brand")
  }

  #close(row) {
    this.#panel(row).classList.add("hidden")
    this.#header(row).setAttribute("aria-expanded", "false")
    this.#header(row).classList.remove("bg-foot")
    this.#chevron(row).classList.remove("rotate-180", "text-brand")
  }

  #panel(row) { return row.querySelector("[data-panel]") }
  #header(row) { return row.querySelector("[data-header]") }
  #chevron(row) { return row.querySelector("[data-chevron]") }
}
